<div *ngIf="showBanner$ | async" class="banner-container">
  <div class="banner-item">
    <div class="banner-text">
      <div class="banner-title">{{ title }}</div>
      <div class="banner-content">{{ content }}</div>
    </div>
  </div>
</div>
